import styled from "styled-components";
import { Colors } from "../../styled";
import { device } from "../../styled/media-queries";

export const ParagraphList = styled.div`
  margin-bottom: 24px;

  > div {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0px;
    }
  }

  input {
    max-width: 400px;
  }
`;

export const ParagraphContainer = styled.div`
  display: flex;
  align-items: center;

  > p {
    margin: 0;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 8px;
  }

  > span {
    padding: 8px;
    font-size: 22px;

    :hover {
      cursor: pointer;
    }
  }
`;

export const TopicContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.07);
  padding: 36px 30px;

  h4.topic__title {
    font-size: 28px;
    line-height: 150%;
    color: #000;
    margin: 0px 0px 16px 0px;
  }

  p.topic__header {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 150%;
    color: ${Colors.Ink};
    margin: 0px 0px 12px 0px;
  }

  .topic__topic-list {
    > div {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      > svg {
        font-size: 14px;
        line-height: 24px;
        margin-right: 8px;
      }

      > span {
        display: block;
        font-size: 16px;
        line-height: 24px;
      }
    }

    > div:last-child {
      margin-bottom: 0px;
    }
  }

  .topic__btn {
    margin-top: 24px;

    button {
      border-radius: 0;
      border: none;
      padding: 10px 28px;
      background: ${Colors.Midnight};
      color: white;
      font-size: 18px;
      line-height: 21px;
      transition: all 0.5s;
  
      &:hover {
        cursor: pointer;
      }
  }
`;

export const QAListContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  max-width: 1200px;
  height: 80vh;
  z-index: 9999;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 56px 56px 74px 100px;

  @media ${device.mobile} {
    top: 0;
    left: 0;
    transform: none;
    width: 100vw;
    height: 100vh;
    padding: 80px 20px 20px 20px;

    .qa__list {
      padding-bottom: 20px;
    }
  }

  .qa__toggle {
    display: flex;
    justify-content: flex-end;

    > svg {
      font-size: 36px;
      line-height: 42px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  h4.qa__header {
    font-size: 28px;
    line-height: 150%;
    margin: 0px 0px 16px 0px;
  }

  .qa__list {
    padding-right: 2rem;

    > div {
      border-bottom: 1px solid #777777;
      padding-bottom: 1rem;
      margin-bottom: 1rem;
    }

    > div:last-child {
      border-bottom: none;
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
`;

export const QAListItemContainer = styled.div`
  .question {
    display: flex;
    align-items: center;

    > p {
      font-size: 16px;
      line-height: 21px;
    }

    .toggle {
      padding: 12px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  p.answer {
    display: ${(props) => (props.visible ? "block" : "none")};
    font-style: italic;
    font-size: 16px;
    line-height: 160%;
    border-left: 3px solid #143b66;
    padding-left: 16px;
  }
`;



// WEBPACK FOOTER //
// ./src/core/admin/components/QA/misc/styled.js